import { SocialPost } from '@/modules/market-signals/model/social-media';

export default function MediaRenderer({ media }: { media: SocialPost['mediaAttachments'] }) {
  if (!media || media.length === 0) return null;

  return (
    <>
      {media.map(m =>
        m.type === 'image' ? (
          <img
            key={m.id}
            src={m.previewUrl || m.url}
            alt=""
            style={{
              maxWidth: '99%',
              width: '400px',
              height: 'auto',
              borderRadius: 4,
            }}
          />
        ) : m.type === 'video' ? (
          <video
            key={m.id}
            controls
            style={{
              maxWidth: '99%',
              width: '400px',
              height: 'auto',
              borderRadius: 4,
            }}
          >
            <source src={m.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : null,
      )}
    </>
  );
}
